module.exports = __webpack_public_path__ + "img/tv.fe6cd415.png";